import { callGet, callPost, callDelete, callPut } from "../integrations/calls";
import { REQ } from "../../libs/constants";

export const getVoucher = async (data, token) => {
  return await callPost(REQ.PURCHASEADV.GET_VOUCHER, data, token);
};

export const saveData = async (data, token) => {
  return await callPost(REQ.PURCHASEADV.SAVE_DATA, data, token);
};

export const trData = async (data, token) => {
  return await callPost(REQ.PURCHASEADV.TR_DATA, data, token);
};

export const getData = async (id, token) => {
  return await callGet(`${REQ.PURCHASEADV.GET_DATA}/${id}`, token);
};

export const descPurchase = async (token) => {
  return await callGet(REQ.PURCHASEADV.ORDER_BY_DESC, token);
};

export const onePreData = async (data, token) => {
  return await callPost(`${REQ.PURCHASEADV.ONE_DAY_PRE}`,data , token)
}

export const oneNextData = async (data, token) => {
  return await callPost(`${REQ.PURCHASEADV.ONE_DAY_NEXT}`,data , token)
}

export const ascPurchase = async (token) => {
  return await callGet(REQ.PURCHASEADV.ORDER_BY_ASC, token);
};

export const updatePurchase = async (data, token) => {
  return await callPut(
    `${REQ.PURCHASEADV.UPDATE_PURCHASE}/${data.id}`,
    data,
    token
  );
};

export const deleteSingleInvoivce = async (id, token) => {
  return await callDelete(
    `${REQ.PURCHASEADV.DELETE_SINGLE_INVOICE}/${id}`,
    {},
    token
  );
};

export const deleteInvoivce = async (id, token) => {
  return await callDelete(`${REQ.PURCHASEADV.DELETE_INVOICE}/${id}`, {}, token);
};

export const getReport = async (token) => {
  return await callGet(`${REQ.PURCHASEADV.GET_REPORT}`, token);
};


